import { render } from "./EditRequest3.vue?vue&type=template&id=19b9fc28"
import script from "./EditRequest3.vue?vue&type=script&lang=js"
export * from "./EditRequest3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__